/**
 * ****************************************************************************
 * @description     :   Main store to control state and data for all app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { createStore } from 'vuex';

/**
 * Import store of modules
 */
import AppStore from './app';

/**
 * Create main store
 */
export default createStore({
    modules: {
        app: AppStore
    }
});
